module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "bs-docs-section",
    attrs: {
      "id": _vm.id
    }
  }, [_vm._c('h1', {
    staticClass: "page-header"
  }, [_vm._c('a', {
    staticClass: "anchor",
    attrs: {
      "href": '#' + _vm.id
    }
  }, [_vm._v(_vm._s(_vm.name))])]), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-28898352", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-28898352!./~/vue-loader/lib/selector.js?type=template&index=0!./docs/example/utils/docSection.vue
// module id = 7
// module chunks = 0